var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"private-rooms-container px-3 pb-5"},[_c('v-img',{staticClass:"mx-auto mt-5",attrs:{"src":"/images/icons/private-rooms.svg","max-width":"50px"}}),_vm._m(0),_c('private-room')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full text-center mt-2"},[_c('span',{staticClass:"text-h6 text-sm-h5 font-weight-800"},[_vm._v("Private Rooms")])])
}]
render._withStripped = true
export { render, staticRenderFns }